<vex-page-layout>
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Desaparecidos</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content [class.px-gutter]="true" class="-mt-6">
        <div class="card overflow-auto -mt-16">
            <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                <div
                    class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                    <input [(ngModel)]="searchKey" (keyup)="applyFilter($event)" autocomplete="off"
                        class="px-4 py-2 border-0 outline-none w-full bg-transparent" placeholder="Buscar..."
                        type="search">
                </div>
                <span class="flex-1"></span>
                <button mat-icon-button type="button" matTooltip="Exportar a pdf" (click)="downloadPdf()">
                    <mat-icon class="text-secondary" svgIcon="mat:picture_as_pdf"></mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Exportar a Excel"
                    (click)="exportarExcel()">
                    <mat-icon class="text-secondary" svgIcon="mat:file_copy"></mat-icon>
                </button>
                <button (click)="syncJuliana()" class="ml-4 flex-none" color="primary" mat-mini-fab
                    matTooltip="Sync Alerta juliana" type="button">
                    <mat-icon svgIcon="mat:sync"></mat-icon>
                </button>
            </div>
            <table [dataSource]="dataSource" class="w-full" mat-table matSort matTableExporter
                #exporter="matTableExporter" id="datasourceTable">
                <ng-container matColumnDef="urlThumbnail">
                    <th *matHeaderCellDef mat-header-cell></th>
                    <td *matCellDef="let row" class="w-8 min-w-8 pr-0" mat-cell>
                        <img [src]="thumbnail(row['id'])" class="avatar h-8 w-8 align-middle">
                    </td>
                </ng-container>
                <ng-container matColumnDef="id">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Identidicador</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.id }}</td>
                </ng-container>
                <ng-container matColumnDef="apellido_paterno">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Paterno</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.apellido_paterno }}</td>
                </ng-container>
                <ng-container matColumnDef="apellido_materno">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Materno</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.apellido_materno }}</td>
                </ng-container>
                <ng-container matColumnDef="nombres">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Nombres</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.nombres }}</td>
                </ng-container>
                <ng-container matColumnDef="documento">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Documento</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.documento }}</td>
                </ng-container>
                <ng-container matColumnDef="sexo">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Sexo</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.sexo }}</td>
                </ng-container>
                <ng-container matColumnDef="nacionalidad">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Nacionalidad</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.nacionalidad }}</td>
                </ng-container>
                <ng-container matColumnDef="departamento">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Departamento</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.departamento }}</td>
                </ng-container>
                <ng-container matColumnDef="provincia">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Provincia</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.provincia }}</td>
                </ng-container>
                <ng-container matColumnDef="municipio">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Municipio</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.municipio }}</td>
                </ng-container>
                <ng-container matColumnDef="encontrado">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Encontrado</th>
                    <td *matCellDef="let element" mat-cell>
                        <div (click)="$event.stopPropagation()" class="flex items-center gap-1">
                            <div [ngClass]="element.encontrado? [stateConstant.SUCCESS_TEXT_CLASS, stateConstant.SUCCESS_BG_CLASS]: [stateConstant.ERROR_TEXT_CLASS, stateConstant.ERROR_BG_CLASS]"
                                class="rounded px-2 py-1 font-medium text-xs flex-none">
                                {{element.encontrado?'Si':'No'}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="fechaDesaparicion">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha desaparición</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.fechaDesaparicion | date:'dd/MM/yyyy HH:mm' }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
                    <td *matCellDef="let element" class="w-10 text-secondary" mat-cell>
                        <button (click)="detail(element)" mat-icon-button type="button">
                            <mat-icon svgIcon="mat:info"></mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS" [pageSize]="appSettings.PAGE_SIZE"
                class="sticky left-0"></mat-paginator>
        </div>
    </vex-page-layout-content>
</vex-page-layout>